import React, { useContext } from "react";
import { LeftVectorIcon } from "assests/GmsIcons";
import { Link } from "react-router-dom";
import { CSContext } from "../contexts/CSContext";
import { areObjectsIdentical } from "Pages/GMS/ISR/Components/RuleComponents/helper";
import { EMPTY_PIVOT_ELEMENT } from "../constants/CSConstants";

const CSConfigHeader = ({ onCLickFunction, linkTo, label, buttonName, childComponent, showBackButton, mode }: CSConfigPropType) => {
    const { resetState, pivotVersionList, pivotList } = useContext(CSContext)

    return (
        <>
            <div className={`tw-px-[21px] tw-pt-[12px] tw-flex tw-justify-between`}>
                {showBackButton ? <Link to={linkTo} onClick={() => resetState()} className="tw-float-left tw-w-[4%] tw-mt-1.5">
                    <LeftVectorIcon />
                </Link> : null}
                <div
                    className={`tw-flex tw-flex-col tw-items-left tw-text-xs tw-w-[96%]`}
                >
                    <label
                        className={`tw-float-right tw-text-black tw-font-noto-sans tw-text-xl tw-font-semibold tw-leading-[25.2px]`}
                    >
                        {label}
                    </label>
                </div>
                {childComponent ? childComponent : null}
                <div className={`tw-flex`}>
                    <div className={`tw-ps-3`}>
                        <button onClick={onCLickFunction} className={`button-style tw-w-max`}
                            disabled={(buttonName !== "Create" && mode === "create" &&
                                pivotList && areObjectsIdentical(pivotList[0], EMPTY_PIVOT_ELEMENT) || (buttonName !== "Create" && pivotVersionList?.length > 0))}
                        >
                            {buttonName}
                        </button>
                    </div>
                </div>
            </div>
        </>
    );
};

export default CSConfigHeader;
